// GET /api/firm/dashboard - the dashboard aggregate; today the web reads
// its priorityQueue section. No fixture fallback: an unreachable server
// throws and the widget says so.

import { getAuthHeaders } from "./auth";

export type QueueSeverity = "critical" | "urgent" | "ai_review" | "normal";

export interface PriorityQueueItem {
  severity: QueueSeverity;
  eID: string;
  clientName: string;
  reason: string;
  deadline?: string;
}

export interface FirmDashboardFeed {
  priorityQueue: PriorityQueueItem[];
}

export async function fetchFirmDashboard(): Promise<FirmDashboardFeed> {
  const res = await fetch("/api/firm/dashboard", {
    headers: { ...getAuthHeaders() },
    credentials: "same-origin",
  });
  if (!res.ok) throw new Error(`Dashboard failed: ${res.status}`);
  const payload = (await res.json()) as { priorityQueue?: PriorityQueueItem[] };
  return { priorityQueue: payload.priorityQueue ?? [] };
}
